/** @jsxImportSource @emotion/react */
import { ODSAlert } from 'bc-ods';
import type { ReactElement, ReactNode } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

type ReloadLinkProps = {
  children?: ReactNode;
};

const ReloadLink = (props: ReloadLinkProps) => {
  const navigate = useNavigate();

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      // eslint-disable-next-line no-script-url
      href="javascript://"
      color="primary-quiet"
      onClick={() => navigate(0)}
    >
      {props.children}
    </a>
  );
};

function LoginUnavailable(): ReactElement {
  const messages = defineMessages({
    LoginUnavailableMessage: {
      id: 'LoginUnavailable.message',
      defaultMessage:
        'Access denied. Check your authentication credentials (e.g. single sign-on or CAC), and <a>try again</a>.',
    },
  });

  return (
    <ODSAlert color="info">
      <FormattedMessage
        {...messages.LoginUnavailableMessage}
        values={{
          a: (chunks) => <ReloadLink>{chunks}</ReloadLink>,
        }}
      ></FormattedMessage>
    </ODSAlert>
  );
}

export default LoginUnavailable;
